export default __webpack_public_path__ + "static/media/ic_close.76866c77.svg";